module.exports = __webpack_public_path__ + "static/media/terminology-supplier.2b62c714.svg";